import React from 'react';
import { Typography, Paper, Card, CardContent } from '@mui/material';
import SpaceManager from '../../../../../components/onboardingForms/SpaceManager';

/**
 * SpacesStep component for the Venue Onboarding Form
 * Allows venue owners to add, edit, and manage venue spaces
 */
export const SpacesStep = ({ 
  spaces, 
  handleSpaceChange, 
  errors 
}) => {
  // Check if there's an error with the spaces field
  const errorMessage = errors?.spaces || null;

  return (
    <Card sx={{ mb: 4 }}>
      <CardContent>
        <Typography variant="h5" gutterBottom>
          Venue Spaces
        </Typography>
        
        <Typography variant="body2" color="text.secondary" paragraph>
          Add the different spaces available at your venue. Each space should have its own details,
          including capacity, area, pricing, and features.
        </Typography>
        
        <Paper elevation={0} variant="outlined" sx={{ p: 3, mb: 3, bgcolor: 'background.default' }}>
          <Typography variant="subtitle1" gutterBottom fontWeight="bold">
            Why is this important?
          </Typography>
          <Typography variant="body2" color="text.secondary">
            Clearly defined spaces help clients understand what your venue offers and find the right
            fit for their needs. Comprehensive details about each space improve visibility in search
            results and increase booking potential.
          </Typography>
        </Paper>
        
        <SpaceManager
          spaces={spaces || []}
          onChange={handleSpaceChange}
          error={errorMessage}
        />
      </CardContent>
    </Card>
  );
};

export default SpacesStep;
